import { Input } from "component/form/input"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { deliveryInfoState } from "state"

export default function Address() {
  const deliveryInfo = useRecoilValue(deliveryInfoState)
  const setDeliveryInfo = useSetRecoilState(deliveryInfoState)

  const handelBlur = (e) => {
    const { value } = e.target
    setDeliveryInfo({
      ...deliveryInfo,
      address: {
        ...deliveryInfo.address,
        validate: value ? "" : "Địa chỉ không được để trống.",
      },
    })
  }

  const handleChange = ({ target }) => {
    setDeliveryInfo({
      ...deliveryInfo,
      address: {
        ...deliveryInfo.address,
        value: target.value,
      },
    })
  }

  return (
    <>
      <Input
        className="deliveryInfomation__input"
        placeholder={"VD: 199 Điện Biên Phủ"}
        value={deliveryInfo.address.value}
        onBlur={handelBlur}
        onChange={handleChange}
        validateText={deliveryInfo.address.validate}
        validateType={'danger'}
        validateClass={'hidden'}
      />

      <span className="text-[#FF424E] text-sm font-normal">
        {deliveryInfo.address.validate}
      </span>
    </>
  )
}
